import React from 'react';
import { NButton } from '@innersource-nn/novoui-react';
import useStack from './hooks/useStack';
import Spinner from 'components/loader/Spinner';
import StackContent from './StackContent';

export interface Stack {
    stackUri: string;
    stack: string;
    accountid: string;
    region: string;
    status: string;
    terminationProtection?: string;
    stackid: string;
    link: string;
    resources: string;
    outputs?: string;
    targetUri?: string;
}
export enum StackType {
    dataset = 'dataset',
    environment = 'environment',
    pipeline = 'pipeline',
    warehouse = 'warehouse',
}

interface StackProps {
    type: StackType;
    uri?: string;
}

const tableHeaders = [
    { header: 'Physical ID', key: 'PhysicalResourceId' },
    { header: 'Resource Type', key: 'ResourceType' },
];
const StackDetails = ({ type, uri }: StackProps) => {
    const { stack, loading, updateStack, updating } = useStack(type, uri);

    const resources = stack.resources
        ? JSON.parse(stack.resources).resources
        : [];
    return (
        <div>
            {loading ? (
                <Spinner />
            ) : (
                <div className="text-true-blue">
                    <div className="flex justify-between py-8">
                        <h2 className="font-semibold text-xl">Stack details</h2>
                        {(type === StackType.dataset ||
                            type === StackType.environment) && (
                            <div>
                                <div className="flex justify-space-evenly gap-8">
                                    <NButton
                                        variant="outline"
                                        onClick={updateStack}
                                        leftIcon="refresh"
                                        square
                                        isLoading={updating}
                                        size="small"
                                    >
                                        Update Stack
                                    </NButton>
                                </div>
                            </div>
                        )}
                    </div>
                    <StackContent
                        stack={stack}
                        resources={resources}
                        tableHeaders={tableHeaders}
                    />
                </div>
            )}
        </div>
    );
};

export default StackDetails;
